module.exports = __webpack_public_path__ + "img/eematico-toys-jucarii-toy-sixpack.2a748bb7.jpg";